<template>
  <f7-page>
    <div>
      <f7-navbar
        sliding
        class="no-shadow"
        :style="appTheme"
      >
        <f7-nav-left name="frmRecuperarMercanciaVolcadaVista-nav-lefth">
          <f7-link @click="NavigateBack()">
            <img
              alt="iconBack"
              src="@/static/icons/back.svg"
            >
          </f7-link>
        </f7-nav-left>
        <f7-nav-title>
          {{ $t('production.dump.retrieve.view.logisticUnit.detailsTitle') }}
        </f7-nav-title>
      </f7-navbar>
      <PCInformacionLineaPunto
        class="navbar-amarillo-1"
        :activo="activo"
      />

      <div class="div-001">
        <PCRecuperarMercanciavolcadaVistaUL
          ref="RecuperarMercancia"
          :unidad-logistica="unidadLogisticaActiva"
          :actualizar="actualizarComponentePCRecuperarMercanciaVolcadaVistaUL"
        />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import PCRecuperarMercanciavolcadaVistaUL from '@/components/production/traceability/PCRecuperarMercanciaVolcadaVistaUL.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmRetrieveOverturnedMerchandiseULView',
  components: {
    PCInformacionLineaPunto,
    PCRecuperarMercanciavolcadaVistaUL,
  },
  props: {
    activo: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      unidadLogisticaActiva: null,
      actualizarComponentePCRecuperarMercanciaVolcadaVistaUL: null,

    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'unidadLogisticaSeleccionada',
      'partidaSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-orange)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    activo(val) {
      if (val) {
        this.ActivarListener();
      } else {
        this.RestablecerValoresDelFrm();
        this.DesactivarListener();
      }
    },
  },
  mounted() {
    this.unidadLogisticaActiva = this.unidadLogisticaSeleccionada;
    this.partidaActiva = this.partidaSeleccionada;
    this.ActivarListener();
  },
  unmounted() {
    this.DesactivarListener();
  },
  methods: {
    NavigateBack() {
      f7.views.main.router.back();
    },
    ActivarListener() {
      Log(this, this.ActivarListener.name);
      eventBus.on('frmRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado', () => {
        this.$refs.RecuperarMercancia.ObtenerElementosRecuperablesDeUnidadLogistica();
        this.actualizarComponentePCRecuperarMercanciaVolcadaVistaUL = new Date();
      });
      eventBus.on('PCRecuperarMercanciaVolcadaUL_mercanciaTotalRecuperada', () => {
        this.MovimientoRealizado();
        f7.views.main.router.back();
      });
    },
    DesactivarListener() {
      Log(this, this.DesactivarListener.name);
      eventBus.off('frmRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado');
      eventBus.off('PCRecuperarMercanciaVolcadaUL_mercanciaTotalVolcada');
    },
    /** Método RestablecerValoresDelFrm */
    RestablecerValoresDelFrm() {
      Log(this, this.RestablecerValoresDelFrm.name);
      this.partidaActiva = '';
      this.unidadLogisticaActiva = '';
    },

    /** Método MovimientoRealizado */
    MovimientoRealizado() {
      Log(this, this.MovimientoRealizado.name);
      eventBus.emit('movimientoRealizado'); // Llama al resto de componentes para su actualización.
    },
  },
};
</script>

<style scoped>
.div-horaRegistroMovimiento {
  border: 1px solid #009ba6;
  background: rgb(0 155 166 / 10%);
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #009ba6;
  font-size: 3.5vw;
  min-height: 25px;
  max-width: 100px;
}

.span-numeroPartida {
  color: var(--his-darkgray);
  font-size: 5vw;
}

.div-contenidofrmRecuperarMercanciaVolcadaVista {
  margin: 20px;
}

.span-ttlElemento {
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
}

.span-textoElemento {
  color: #009ba6;
  font-size: 14px;
  font-weight: 500;
}

.div-informacionDelDetalle {
  margin-top: 21px;
}

.row {
  padding-bottom: 15px;
}
</style>
